import { IUserDTO } from './';

export interface IBaseEntityDTO {
  id: string;
  created_on: Date;
  modified_on: Date;
  created_by?: IUserDTO;
  modified_by?: IUserDTO;
  deleted: boolean;
}

export class BaseEntityDTO implements IBaseEntityDTO {
  id: string;
  created_on: Date;
  modified_on: Date;
  created_by?: IUserDTO;
  modified_by?: IUserDTO;
  deleted: boolean;

  constructor(data?: Partial<BaseEntityDTO>) {
    this.id = data?.id ?? '';
    this.created_on = data?.created_on ?? new Date();
    this.modified_on = data?.modified_on ?? new Date();
    this.deleted = data?.deleted ?? false;
  }
}
